// static - only top level routes management
// dynaic - will be defined in the corresponding components

import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import LoginRoute from './shared/javascripts/components/LoginRoute'
import HomePage from './HomePage'
import ManagerDashboard from './manager/javascripts/components/Dashboard'
import AdminStatusDashboard from './admin/statuses/javascripts/components/AdminStatusDashboard'
import Users from './manager/javascripts/components/Users/Users'
import UserReportContainer from './reports/general/javascripts/containers/User/UserReportContainer'
import GooglePlayUserReport from './reports/google_play/javascripts/components/User/UserReport'
import StaffDashboard from './staff/javascripts/components/Dashboard'
import LoginPage from './authentication/javascripts/components/LoginPage'
import NotFound from './shared/javascripts/components/NotFound'
import AuthenticatedRoute from './shared/javascripts/components/AuthenticatedRoute'
import Authorization from './shared/javascripts/hocs/Authorization'
import {
  MANAGER,
  ADMIN,
  STAFF
} from './shared/javascripts/helpers/userRoles'

const AppRoutes = ( {currentUser} ) => {
  // So, we make sure currentUser will be available always
  if(!currentUser) {return <Redirect to="/login"/>}

  // authorize with allowed roles
  const Manager = Authorization([MANAGER, ADMIN])
  const Staff = Authorization([MANAGER, ADMIN, STAFF])

  return(
    <Switch>
      <AuthenticatedRoute exact path="/" component={HomePage}/>
      <LoginRoute path="/login" component={LoginPage} currentUser={currentUser} />
      <AuthenticatedRoute exact path='/manager/activity_logs' component={NotFound} />
      <AuthenticatedRoute exact path='/manager/statistics' component={NotFound} />
      <AuthenticatedRoute exact path='/manager/users/:userId/reports' component={Manager(UserReportContainer)} />
      <AuthenticatedRoute exact path='/manager/users/:userId/old_reports' component={Manager(GooglePlayUserReport)} />
      <AuthenticatedRoute exact path='/manager/users' component={Manager(Users)} />
      <AuthenticatedRoute exact path="/manager" component={Manager(ManagerDashboard)}/>

      <AuthenticatedRoute exact path="/staff/:userId/reports" component={Staff(UserReportContainer)} />
      <AuthenticatedRoute exact path="/staff" component={Staff(StaffDashboard)} />
      <AuthenticatedRoute exact path="/manager/statuses" component={Manager(AdminStatusDashboard)} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default AppRoutes


// WEBPACK FOOTER //
// ./src/routes.jsx